import { useState } from 'react';
import toast from 'react-hot-toast';
import api from '../api';

// Prepara e imprime un cheque ya aprobado. Lo usan tanto la bandeja de
// Aprobaciones (Aprobador/Admin) como el Historial (para que quien lo
// solicitó también pueda imprimirlo una vez aprobado, sin depender de que
// lo haga el aprobador).
export function useImpresionCheque(onImpreso) {
  const [preparando, setPreparando] = useState(null); // { cheque, banco, calibracion }
  const [cargando, setCargando] = useState(false);

  async function prepararImpresion(cheque) {
    setCargando(true);
    try {
      const res = await api.get(`/bancos/${cheque.banco}/plantilla/`);
      setPreparando({ cheque, banco: res.data.banco, calibracion: res.data });
    } catch {
      toast.error('No se pudo cargar la calibración de este banco.');
    } finally {
      setCargando(false);
    }
  }

  async function confirmarImpresion() {
    const { cheque } = preparando;
    try {
      await api.post(`/cheques/${cheque.id}/imprimir/`);
      // OJO: no desmontamos la vista previa acá. window.print() no bloquea
      // la ejecución en Chrome (abre el diálogo y sigue corriendo el JS de
      // inmediato), así que si sacábamos #cheque-lienzo del DOM justo
      // después, la hoja de impresión salía en blanco. El usuario cierra la
      // vista previa a mano con el botón una vez que termina.
      window.print();
      onImpreso?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'No se pudo marcar como impreso.');
    }
  }

  function cancelar() {
    setPreparando(null);
  }

  return { preparando, cargando, prepararImpresion, confirmarImpresion, cancelar };
}
